/**
 * Categorie du module annonce
 */
export class AnnonceCategorie {
    /**
     * Constructeur de l'annonceCategorie
     * @param annonceCategorie à construire
     */
    constructor(annonceCategorie) {
        if (annonceCategorie) {
            const { idAnnonceCategorie, idPere, libelle, url, payant, pub, metaDescription, actif, ordre } = annonceCategorie;
            this.idAnnonceCategorie = idAnnonceCategorie;
            this.idPere = idPere;
            this.libelle = libelle;
            this.url = url;
            this.payant = payant;
            this.pub = pub;
            this.metaDescription = metaDescription;
            this.actif = actif;
            this.ordre = ordre;
        }
    }
    /**
     * Méthode de renvoie de l'objet en back sous la forme d'un tableau
     * @return array
     */
    toRaw() {
        return {
            idAnnonceCategorie: this.idAnnonceCategorie,
            idPere: this.idPere,
            libelle: this.libelle,
            url: this.url,
            payant: this.payant,
            pub: this.pub,
            metaDescription: this.metaDescription,
            actif: this.actif,
            ordre: this.ordre,
        };
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQW5ub25jZUNhdGVnb3JpZS5jbGFzcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIkFubm9uY2VDYXRlZ29yaWUuY2xhc3MudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSCxNQUFNLE9BQU8sZ0JBQWdCO0lBZ0Q1Qjs7O09BR0c7SUFDSCxZQUFtQixnQkFBNEM7UUFDOUQsSUFBSSxnQkFBZ0IsRUFBRTtZQUNyQixNQUFNLEVBQUUsa0JBQWtCLEVBQUUsTUFBTSxFQUFFLE9BQU8sRUFBRSxHQUFHLEVBQUUsTUFBTSxFQUFFLEdBQUcsRUFBRSxlQUFlLEVBQUUsS0FBSyxFQUFFLEtBQUssRUFBRSxHQUFHLGdCQUFnQixDQUFDO1lBRWxILElBQUksQ0FBQyxrQkFBa0IsR0FBRyxrQkFBa0IsQ0FBQztZQUM3QyxJQUFJLENBQUMsTUFBTSxHQUFHLE1BQU0sQ0FBQztZQUNyQixJQUFJLENBQUMsT0FBTyxHQUFHLE9BQU8sQ0FBQztZQUN2QixJQUFJLENBQUMsR0FBRyxHQUFHLEdBQUcsQ0FBQztZQUNmLElBQUksQ0FBQyxNQUFNLEdBQUcsTUFBTSxDQUFDO1lBQ3JCLElBQUksQ0FBQyxHQUFHLEdBQUcsR0FBRyxDQUFDO1lBQ2YsSUFBSSxDQUFDLGVBQWUsR0FBRyxlQUFlLENBQUM7WUFDdkMsSUFBSSxDQUFDLEtBQUssR0FBRyxLQUFLLENBQUM7WUFDbkIsSUFBSSxDQUFDLEtBQUssR0FBRyxLQUFLLENBQUM7U0FDbkI7SUFDRixDQUFDO0lBRUQ7OztPQUdHO0lBQ0ksS0FBSztRQUNYLE9BQU87WUFDTixrQkFBa0IsRUFBRSxJQUFJLENBQUMsa0JBQWtCO1lBQzNDLE1BQU0sRUFBRSxJQUFJLENBQUMsTUFBTTtZQUNuQixPQUFPLEVBQUUsSUFBSSxDQUFDLE9BQU87WUFDckIsR0FBRyxFQUFFLElBQUksQ0FBQyxHQUFHO1lBQ2IsTUFBTSxFQUFFLElBQUksQ0FBQyxNQUFNO1lBQ25CLEdBQUcsRUFBRSxJQUFJLENBQUMsR0FBRztZQUNiLGVBQWUsRUFBRSxJQUFJLENBQUMsZUFBZTtZQUNyQyxLQUFLLEVBQUUsSUFBSSxDQUFDLEtBQUs7WUFDakIsS0FBSyxFQUFFLElBQUksQ0FBQyxLQUFLO1NBQ2pCLENBQUM7SUFDSCxDQUFDO0NBQ0QifQ==